require("./certifications.scss");

var $ = require("jquery");

$(function () {
    const loadComponents = () => {
        $("#certification_tiles").children().each(function () {
            const elm = $(this);
            $(elm.data("target")).append(elm);
        });
    };

    loadComponents();

    $(".certifications a[data-toggle=tooltip]").tooltip();

    $(".certifications a").click(function (e) {
        e.preventDefault();

        $.colorbox({
            href: $(this).data("targetUrl"),
            opacity: 0.95,
            fixed: true,
            transition: "none"
        });
    });
});